"use client";
import React, { Suspense } from "react";
import { VStack } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { PRICING_HEADING_CONSTANTS } from "./constants";
import { tablist } from "./pricingTabsList";

const PricingTabs = () => {
  const headingVariant = useHeadingVariant();
  return (
    <VStack id="pricing" gap={4}>
      <Heading as="h1" variant={headingVariant}>
        {PRICING_HEADING_CONSTANTS.title}
      </Heading>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
      <Button
        variant={"ideal"}
        onClick={() => scrollToElement("contact-us", 120)}
        alignSelf={"center"}
        justifySelf={"center"}
        px={6}
      >
        Ready To Buy?
      </Button>
    </VStack>
  );
};

export default PricingTabs;
